import { SideBarItem } from "@/components/app/SideBars/SideBarItem.tsx"
import { SideBar } from "@/components/app/SideBars/SideBar.tsx"
import { View } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"

export function UserSideBar() {
  return (
    <View UNSAFE_className="sm:block hidden" height="100%">
      <SideBar position="right">
        <SideBarItem label="Dashboard" route="dashboard" />
        <SideBarItem label="OP Module" route="opModule" />
        <SideBarItem label="Incident Reporting" route="incidentReporting" />
        <SideBarItem label="ER Dashboard" route="erDashboard" />
        <SideBarItem label="Quality Indicators" route="qualityIndicators" />
        <SideBarItem label="Dialysis" route="dialysisDashboard" />
        <SideBarItem label="Referrals" route="referrals" />
        <SideBarItem label="Analytics" route="analytics" />
        <SideBarItem label="AMS" route="ams" />
        <SideBarItem label="Cathlab" route="cathlab" />
        <SideBarItem label="Dietetics" route="dietetics" />
        <SideBarItem
          label="Discharge Summary"
          route="dischargeSummaryDashboard"
        />
        <SideBarItem
          label="Operation Theatre"
          route="operationTheatreDashboard"
        />
        <SideBarItem label="All Patients" route="allPatients" />
        <SideBarItem label="Oncall Rotas" route="onCallRotas" />
        <SideBarItem label="Nursing" route="nursingDashboard" />
        <SideBarItem label="DMO Roster" route="dmoRoster" />
        <SideBarItem label="Dialysis Config" route="dialysisConfig" />
        <SideBarItem label="Master" route="master" />
        <SideBarItem label="User Management" route="userManagement" />
        <SideBarItem label="Inv Charts" route="invCharts" />
        <SideBarItem label="Release Notes" route="releaseNotes" />
        <SideBarItem label="Policy Documents" route="policyDocuments" />
        <SideBarItem label="User Guide" route="userGuide" />
      </SideBar>
    </View>
  )
}
